module.exports = __webpack_public_path__ + "img/avatar_zorro.ee528f14.svg";